export default "__VITE_ASSET__sfAyTBsl__"